module.exports = "<div id=\"extr-page\">\r\n<router-outlet></router-outlet>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/layout/app-layouts/auth-layout.component.html
// module id = 900
// module chunks = 85